import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';
import type { Currency } from '@vy/types';
import { DEFAULT_CURRENCY } from '@vy/types';
import { isFinite } from 'lodash';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { NumberDisplay } from './NumberDisplay/NumberDisplay';
import { VyTooltip, type VyTooltipProps } from '../new-design/VyTooltip';

type PriceProps = Omit<TypographyProps, 'align'> & {
  children: React.ReactNode;
  currency?: Currency;
  rounded?: boolean;
  animated?: boolean;
  align?: 'left' | 'center' | 'right' | 'unset';
  slots?: {
    Tooltip?: {
      props?: Omit<VyTooltipProps, 'tooltipContent' | 'children'>;
    };
  };
  fractionDigits?: number;
  prefix?: React.ReactNode;
  formattingStyle?: 'percent' | 'currency' | 'unit' | 'decimal';
};

export const Price: React.FC<PriceProps> = ({
  children,
  currency = DEFAULT_CURRENCY,
  align = 'unset',
  slots,
  fractionDigits,
  ...props
}) => {
  const childAsNumber = Number(children);

  if (isFinite(childAsNumber)) {
    return (
      <NumberDisplay {...props} currency={currency} align={align} fractionDigits={fractionDigits}>
        {childAsNumber}
      </NumberDisplay>
    );
  }

  return (
    <VyTooltip tooltipContent={children} placement="top" {...slots?.Tooltip?.props}>
      <Typography {...props} className={twMerge('w-[6ch] truncate font-sans', props?.className)}>
        {children}
      </Typography>
    </VyTooltip>
  );
};
